<template>
  <div style="height: 30px;" />

  <router-view />

  <BottomNavBar v-if="isLoggedIn" />
</template>

<script setup>
import { useUserStore } from '@/stores/user'
import { computed, onMounted } from 'vue'
import BottomNavBar from './components/bottom-nav-bar/BottomNavBar.vue';

const userStore = useUserStore()
onMounted(() => {
  userStore.fetchUser()
})
const isLoggedIn = computed(() => userStore.isLoggedIn)
</script>

<style lang="scss">
body {
  background-color: #000;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}

@import '@/assets/styles/main.scss';
</style>
